import type { FC } from 'react';

import ProgressBarRow from '@/common-components/charts/ProgressBarRow';
import { CATEGORY_META } from '@/features/analytics/constants';
import type { CategoryShare } from '@/types/stats.types';

interface TopCategoriesCardProps {
  categories: CategoryShare[];
}

const TopCategoriesCard: FC<TopCategoriesCardProps> = ({ categories }) => (
  <section className="rounded-2xl border border-[var(--color-divider)] bg-white p-6 shadow-[var(--shadow-card)]">
    <h2 className="mb-4 text-[15px] font-extrabold text-[var(--color-ink)]">
      Top Rented Categories
    </h2>

    {categories.length === 0 ? (
      <p className="py-8 text-center text-[13px] text-[var(--color-ink-muted)]">
        No rentals booked yet.
      </p>
    ) : (
      <div className="flex flex-col gap-3">
        {categories.map((category) => {
          const meta = CATEGORY_META[category.category];
          return (
            <ProgressBarRow
              key={category.category}
              label={`${meta?.icon ?? '📦'} ${meta?.label ?? category.category}`}
              value={`${category.percent}%`}
              percent={category.percent}
              accent={meta?.accent ?? 'brand'}
              thick
            />
          );
        })}
      </div>
    )}
  </section>
);

export default TopCategoriesCard;
